
import React, { useMemo, useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import SAlert from '../shared/SAlert';
import useUtils from '../../../utiles/useUtiles';
import Footer from '../../components/Footer';

import ModalAddUser from './ModalAddUser';
import { ROLE_ADMIN, STATUS_ACTIVE } from '../../../utiles/constants';
import { Badge } from 'react-bootstrap';
import Swal from 'sweetalert2';

const Users: React.FC = () => {

	const [showAddUserModal, setShowAddUserModal] = useState<boolean>(false);
	const [usersList, setUsersList] = useState<any>({ count: 0, rows: [] });
	const [loading, setLoading] = useState<boolean>(false);
	const [showSuspendAlert, setShowSuspendAlert] = useState<boolean>(false);
	const [showActiveAlert, setShowActiveAlert] = useState<boolean>(false);
	const [selectedUser, setSelectedUser] = useState<any | null>(null);
	const [pagination, setPagination] = useState<any>({
		pageIndex: 0,
		pageSize: 10
	});
	const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
	const axios = axiosRequest();
	const toast = toastInstance();

	useEffect(() => {
		fetchUsers();
	}, [pagination.pageIndex, pagination.pageSize]);

	const closeModal = () => {
		setShowAddUserModal(false);
		setSelectedUser(null);
		fetchUsers();
	};


	const columns = useMemo(
		() => [
			{
				accessorKey: 'role',
				header: 'Role',
				minSize: 50,
				maxSize: 120,
				Cell: ({ cell }: any) => {
					const role = cell.getValue();
					return <Badge
						variant={role === ROLE_ADMIN ? 'primary' : 'info'}>
						{role === ROLE_ADMIN ? 'Admin' : 'Virtual Assistant'}
					</Badge>;
				},
			},
			{
				accessorKey: 'name',
				header: 'Name',
				minSize: 50,
				maxSize: 120,
				Cell: ({ cell }: any) => <span>{cell.getValue()}</span>,
			},
			{
				accessorKey: 'email',
				header: 'Email',
				minSize: 50,
				maxSize: 120,
				Cell: ({ cell }) => <span>{cell.getValue()}</span>,
			},
			{
				accessorKey: 'phone',
				header: 'Phone',
				minSize: 50,
				maxSize: 120,
				Cell: ({ cell }) => <span>{cell.getValue() || 'NA'}</span>,
			},
			{
				accessorKey: 'status',
				header: 'Status',
				minSize: 50,
				maxSize: 120,
				Cell: ({ cell }: any) => {
					const status = cell.getValue();
					return <Badge
						variant={status === STATUS_ACTIVE ? 'success' : 'danger'}>
						{status === STATUS_ACTIVE ? 'ACTIVE' : 'DEACTIVATED'}
					</Badge>;
				},
			},
			{
				accessorKey: 'actions',
				header: 'Action',
				minSize: 30,
				maxSize: 60,
				Cell: ({ cell }) => <div>
					<FontAwesomeIcon
						icon={faPencil}
						className="isPointer ml-2"
						onClick={() => editUser(cell.row.original)}
					/>
				</div>,
			},
			{
				accessorKey: 'actions',
				header: 'Delete',
				minSize: 30,
				maxSize: 60,
				Cell: ({ cell }) => {
					console.log(cell);
					if (cell.row.original.email !== "admin@yopmail.com") {
						return (
							<div>
								<FontAwesomeIcon
									icon={faTimesCircle}
									className="isPointer ml-2 text-danger"
									onClick={() => deleteUser(cell.row.original.id)}
								/>
							</div>
						)
					} else {
						return <></>
					}
				},
			}
		],
		[],
	);

	const editUser = (record: any) => {
		setShowAddUserModal(true);
		setSelectedUser(record);
	};

	const fetchUsers = async () => {
		setLoading(true);
		const request = await axios.get(`${baseUrl()}/csv-tool/users?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}`);
		const { error, msg, data } = request.data;
		setLoading(false);
		if (error) {
			toast.error(msg);
		} else {
			setUsersList(data);
		}
	};

	const confirmSuspend = (record: any) => {
		setShowSuspendAlert(true);
		setSelectedUser(record);
		// setCallback(suspendUser())
	};

	const confirmActive = (record: any) => {
		setShowActiveAlert(true);
		setSelectedUser(record);
		// setCallback(activeUser())
	};

	const suspendUser = async () => {
		setLoading(true);
		setShowSuspendAlert(false);
		const request = await axios.put(`${baseUrl()}/csv-tool/users/${selectedUser.id}`, { status: 0 });
		const { error, msg } = request.data;
		setLoading(false);
		if (error) {
			toast.error(msg);
		} else {
			toast.success(msg);
			fetchUsers();
		}
	};

	const activeUser = async () => {
		setLoading(true);
		setShowActiveAlert(false);
		const request = await axios.put(`${baseUrl()}/csv-tool/users/${selectedUser.id}`, { status: 1 });
		const { error, msg } = request.data;
		setLoading(false);
		if (error) {
			toast.error(msg);
		} else {
			toast.success(msg);
			fetchUsers();
		}
	};

	const deleteUser = async (account_id: number = 0) => {
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, delete it!'
		}).then(async (result) => {
			if (result.isConfirmed) {
				setLoading(true);
				try {
					if (account_id === 0) throw new Error('Invalid user');
					setLoading(true);
					const request = await axios.delete(`${baseUrl()}/csv-tool/users/delete/${account_id}`);
					const { error, msg } = request.data;
					if (error) throw new Error(msg);
					toast.success(msg);
					fetchUsers();
				} catch (error: any) {
					toast.error(error);
				} finally {
					setLoading(false);
				}
			}
		});
	};

	return (
		<>
			<div className="container-fluid">
				<div className="row">
					<div className="col-sm-12">
						<div className="main-container">
							<div className="main-container-inner">
								{/* <div className="logo mb-3"><img src="logo-min.png" /></div> */}
								<div className="main-card revrex-data-table-card">
									<div className='d-flex justify-content-between align-items-center mb-3'>
										<h1 className='page-title-sm'>Admin & VA Users</h1>
										<button className='btn btn-md btn-custom-secondary' onClick={() => setShowAddUserModal(true)}>
											{/* <FontAwesomeIcon icon={faSave} />  */}
											Add
										</button>
									</div>
									<MaterialReactTable
										columns={columns}
										data={usersList?.rows}
										rowCount={usersList?.count}
										enableColumnOrdering={false}
										enableRowSelection={false}
										enableSelectAll={false}
										enableColumnActions={false}
										manualPagination
										onPaginationChange={setPagination}
										state={{ pagination }}
										enableSorting={false}
										enableGlobalFilter={false}
										enableFullScreenToggle={false}
										enableDensityToggle={false}
										enableHiding={false}
										enableColumnFilters
										enableFilters={false}
									/>
								</div>
							</div>
							<Footer />
						</div>
					</div>
				</div>
			</div>
			{showAddUserModal && <ModalAddUser show={showAddUserModal} handleClose={closeModal} selectedUser={selectedUser} />}
			<SAlert
				show={showSuspendAlert}
				showCancel
				confirmBtnText="Yes"
				cancelBtnText="No"
				confirmBtnBsStyle="primary"
				cancelBtnBsStyle="secondary"
				onCancel={() => setShowSuspendAlert(false)}
				title={`Are you sure to suspend the user, ${selectedUser?.name}?`}
				onConfirm={() => suspendUser()}
			/>
			<SAlert
				show={showActiveAlert}
				showCancel
				confirmBtnText="Yes"
				cancelBtnText="No"
				confirmBtnBsStyle="primary"
				cancelBtnBsStyle="secondary"
				onCancel={() => setShowActiveAlert(false)}
				title={`Are you sure to activate the user, ${selectedUser?.name}?`}
				onConfirm={() => activeUser()}
			/>
			{loadingScreen(loading)}
		</>
	);
}

export default Users